import template from './inputDatepicker.html';
import controller from './inputDatepicker.controller';
import './inputDatepicker.scss';

let inputDatepickerComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    onDatepick: '&',
    disabled: '<',
    name: '@',
    startDate: '<',
    initDate: '<',
    disableBeforeStartDate: '@',
    isMobileApp: '<',
    minDate: '<',
    isRequired: '<',
  },
  template,
  controller
};

export default inputDatepickerComponent;



// WEBPACK FOOTER //
// ./client/app/components/inputDatepicker/inputDatepicker.component.js